import * as d3 from "d3";
import {
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    addGridlines,
    axisTextDim1,
    colonAnnotation, contextMenu, createTooltip,
    fw_progressive_1way, generateDownloadData,
    inrFormatter,
    numberFormat,
    responsivefy
} from '../functions'
import {legendColor} from "d3-svg-legend";

export default function (chart, divId, vizName,resData, filterParam,checkbox,gridflag) {
    console.log("Chart vizName called:", vizName, divId)

    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 400,
        margin: { top: 30, right: 170, bottom: 100, left: 80 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    var size = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + "px"
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName


    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chartWidth + chartMargin.left + chartMargin.right)
        .attr("height", chartHeight + chartMargin.top + chartMargin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform", "translate(" + chartMargin.left + "," + chartMargin.top + ")");

    var g = svg.append("g")

    // axios.post(url, filterParam).then(res => {
        let data = resData

        data = data.filter(function (d) {
            return d.dim1_name == d.dim1_name
        })
        var dataXAxis = d3.nest()
            .key(d => {
                return d.dim2_name;
            })
            .key(d => {
                return d.dim1_name;
            })
            .rollup(v => {
                return d3.sum(v, d => {
                    return d.metric1;
                });
            })
            .entries(data);

        dataXAxis.forEach(y => {
            y.year = y.key;
            y.values.forEach(d => {
                d.dim1_name = d.key;
                d.sumTotalCost = +d.value;
            });
           /* y.values.sort((a, b) => {
                return b.sumTotalCost - a.sumTotalCost;
            });*/
        });

        var mainCategoryList = dataXAxis[0].values.map(d => {
            return d.dim1_name;
        });
        var yearList = dataXAxis.map(d => {
            return d.year;
        });

        console.log("stacked data", data, dataXAxis, yearList)

        var y1legend = g.append('g').attr('transform', `translate(${chartWidth + 20}, 0)`);
        var x1Scale = d3.scaleBand().rangeRound([0, chartWidth]).paddingInner(0.3);
        var x2Scale = d3.scaleBand().padding(.1);
        var y1Scale = d3.scaleLinear().rangeRound([chartHeight, 0]);
        var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way);

        x1Scale.domain(yearList);
        x2Scale.domain(mainCategoryList).rangeRound([5, x1Scale.bandwidth()]);
        y1Scale.domain([0, d3.max(dataXAxis, d => {
            return d3.max(d.values, el => {
                return el.sumTotalCost;
            });
        })]).nice();
        metric1ColorScale.domain(mainCategoryList);
        // Should there be a class for tooltip?
        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip'+divId.id)
            .html(d => d.dim1_name+ colonAnnotation +  numberFormat(d.sumTotalCost));

        svg.call(y1tip)*/

        if (gridflag === true) {
            addGridlines(svg, x1Scale, y1Scale, chart);
        }

        // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        // var div = d3.select(divId).append('div').attr('class', 'tooltip')
        //     .attr('style', 'position: absolute; opacity: 0;')
         const tooltip = createTooltip(divId);

        var year = g.append("g")
            .selectAll("g")
            .data(dataXAxis)
            .enter()
            .append("g")
            .attr("transform", d => {
                return "translate(" + x1Scale(d.year) + ",0)";
            })

        var rect = year.selectAll(".bar")
            .data(d => {
                return d.values;
            })
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("y", chartHeight)
            .attr("width", x1Scale.bandwidth())
            .attr("height", 0)
            .attr("fill", d => {
                return metric1ColorScale(d.dim1_name);
            })
            .on('mouseover', function( d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return d.dim1_name + colonAnnotation + numberFormat(d.sumTotalCost)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on('mouseout', function() {
                tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
            })
            .on('contextmenu', function(d) {
                const parentData = d3.select(this.parentNode).datum();
                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name],          // e.g., "metric1"
                    [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]:[parentData.key]
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            });

        rect.transition()
            .duration(300)
            .attr('class', d => `data-point ${d.dim1_name}`)
            .attr("x", d => {
                return x2Scale(d.dim1_name);
            })
            .attr("y", d => {
                return y1Scale(d.sumTotalCost);
            })
            .attr("width", x2Scale.bandwidth())
            .attr("height", d => {
                return chartHeight - y1Scale(d.sumTotalCost)
            })

        svg.append("g")
            .attr("class", "axisL20")
            .attr("transform", "translate(0," + chartHeight + ")")
            .call(d3.axisBottom(x1Scale))
            .selectAll('text')
            .style('font-size', fontSize)
            .style('text-anchor', 'end')
            // .attr('dx', '-1em')
            .attr('dy', '-0.05em')
            //.attr('dx', XaxisAttribute)
            .attr('transform', 'rotate(-50)')
            .text(axisTextDim1)

        svg.append("g")
            .attr("class", "axisL20")
            .call(d3.axisLeft(y1Scale).tickFormat(inrFormatter))
            .selectAll('text')
            .style('font-size', fontSize);

        svg.append("text")
            .attr("x", (chartWidth / 2))
            .attr("y", chartHeight + (chartMargin.bottom - 20))
            .style("fill", fontColor)
            .style("text-anchor","middle")
            .text(chart.x1AxisDisplayName)
            .style('font-size', axisLabelFontSize);

        svg.append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - chartMargin.left + 10)
            .attr("x", 0 - (chartHeight / 2))
            .attr("dy", "1em")
            .style("text-anchor", "middle")
            .style("fill", fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', axisLabelFontSize);

        // color legend
        var selected = '';
        var y2legend = legendColor()
            .scale(metric1ColorScale)
            .shape('rect') //rect to circle for the circle legend
            .shapeWidth(12)
            .shapeHeight(12)
            .labelOffset(4)
            //                .shapeRadius(5)
            .on('cellclick', function (d) {
                d3.selectAll("rect").style("opacity", 1)
                if (selected !== d) {
                    d3.selectAll("rect")
                        .filter(function (e) {
                            return e !== d.dim1;
                        })
                        .style("opacity", 0)
                    selected = d
                } else {
                    selected = ''
                }
                var legendCell = d3.select(this);
                legendCell.classed('hidden', !legendCell.classed('hidden'));
            })

        y1legend.call(y2legend);
        y1legend.selectAll('.cell text')
            .style('font-size', fontSize);
        y1legend.selectAll('.cell rect')
            .attr('rx', 25)
            .attr('ry', 25);

        d3.selectAll("input").on("change", change);
        var timeout = setTimeout(() => {
            d3.select("input[value=\"grouped\"]").property("checked", true).each(change);
        }, 2000);

        function change() {
            clearTimeout(timeout);
            if (this.value === "grouped") transitionGrouped();
            else transitionStacked();
        }

        function transitionGrouped() {
            rect.transition()
                .duration(300)
                .attr("x", d => {
                    return x2Scale(d.dim1);
                })
                .attr("width", x2Scale.bandwidth())
                .transition()
                .attr("y", d => {
                    return y1Scale(d.sumTotalCost);
                })
                .attr("height", d => {
                    return chartHeight - y1Scale(d.sumTotalCost);
                });
        }

        function transitionStacked() {
            rect.transition()
                .duration(300)
                .attr("y", d => {
                    return y1Scale(d.sumTotalCost);
                })
                .attr("height", d => {
                    return chartHeight - y1Scale(d.sumTotalCost);
                })
                .transition()
                .attr("x", d => {
                    return x1Scale(d.dim1);
                })
                .attr("width", 100);
        }
    // });
}
